<script lang="ts">
	let {
		width = '100%',
		height = '1em',
		class: className = '',
		rounded = false,
		circle = false,
		lines = 1,
		spacing = '0.5em'
	}: {
		width?: string;
		height?: string;
		class?: string;
		rounded?: boolean;
		circle?: boolean;
		lines?: number;
		spacing?: string;
	} = $props();
</script>

<div class="skeleton-container {className}">
	{#each Array(lines) as _, i}
		<div
			class="skeleton {circle ? 'skeleton--circle' : rounded ? 'skeleton--rounded' : ''}"
			style:width
			style:height
			style:margin-bottom={i < lines - 1 ? spacing : '0'}
		></div>
	{/each}
</div>

<style>
	.skeleton-container {
		display: flex;
		flex-direction: column;
	}
	
	.skeleton {
		background: linear-gradient(
			90deg,
			var(--bg-secondary) 25%,
			var(--bg-tertiary) 50%,
			var(--bg-secondary) 75%
		);
		background-size: 200% 100%;
		animation: skeleton-loading 1.5s ease-in-out infinite;
		border-radius: var(--radius-sm);
	}
	
	.skeleton--rounded {
		border-radius: var(--radius-md);
	}
	
	.skeleton--circle {
		border-radius: 50%;
		aspect-ratio: 1;
	}
	
	@keyframes skeleton-loading {
		0% {
			background-position: 200% 0;
		}
		100% {
			background-position: -200% 0;
		}
	}
	
	/* Reduced motion support */
	@media (prefers-reduced-motion: reduce) {
		.skeleton {
			animation: none;
			background: var(--bg-secondary);
		}
	}
</style>